videojs.addLanguage('no', 
 {
  "Play": "Play",
  "Pause": "Pause",
  "Current Time": "Current Time",
  "Duration Time": "Duration Time",
  "Remaining Time": "Remaining Time",
  "Stream Type": "Stream Type",
  "LIVE": "LIVE",
  "Loaded": "Loaded",
  "Progress": "Progress",
  "Fullscreen": "Fullscreen",
  "Non-Fullscreen": "Non-Fullscreen",
  "Mute": "Mute",
  "Unmuted": "Unmuted",
  "Playback Rate": "Playback Rate",
  "Subtitles": "Undertekster",
  "subtitles off": "Undertekster av",
  "Captions": "Captions",
  "captions off": "captions off",
  "Chapters": "Chapters",
  "You aborted the video playback": "You aborted the video playback.",
  "A network error caused the video download to fail part-way.": "Videoavspillingen stoppet plutselig, sjekk nettilkoblingen din.",
  "The video could not be loaded, either because the server or network failed or because the format is not supported.": "Filmfilen er ødelagt eller så støttes ikke formatet av din nettleser.",
  "The video playback was aborted due to a corruption problem or because the video used features your browser did not support.": "Denne filmfilen er enten ikke tilgjengelig eller så støttes ikke formatet av din nettleser.",
  "No compatible source was found for this video.": "Ingen film er lastet."
});